export default {
  MCHASHID: "MCHASHID"
};



// WEBPACK FOOTER //
// ./src/config/cookieType.js